import { BASEURL } from '../../utilites';
import axios from 'axios';
import { MEMBERSHIP_ACTION_TYPE } from './Type';
import allActions from '../action';

//  Function To POST Membership
const initialRegisterMembership = () => {
	return async (dispatch) => {
		axios
			.post(`${BASEURL}/api/membership/register-usermembership`)
			.then((response) => {
				// HANDLE RESPONSE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.registerMembership,
					payload: {
						message: 'success',
						status: response?.data?.success,
						data: response?.data?.data,
					},
				});
			})
			.catch((error) => {
				// HANDLE ERROR MESSAGE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.registerMembership,
					payload: {
						message: handleMembershipError('simple', error),
						status: false,
						data: {},
					},
				});
			});
	};
};
const getMembership = (id) => {
	return async (dispatch) => {
		axios
			.post(`${BASEURL}/api/membership/get-usermembership`, {id})
			.then((response) => {
				// HANDLE RESPONSE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.getMembership,
					payload: {
						message: 'success',
						status: response?.data?.success,
						data: response?.data?.data,
					},
				});
			})
			.catch((error) => {
				// HANDLE ERROR MESSAGE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.getMembership,
					payload: {
						message: handleMembershipError('simple', error),
						status: false,
						data: {},
					},
				});
			});
	};
};
const updateMembership = (membershipData) => {
	
	return async (dispatch) => {
		axios
			.patch(`${BASEURL}/api/membership/update-usermembership-byAdmin`, membershipData)
			.then((response) => {
				// HANDLE RESPONSE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.updateMembership,
					payload: {
						message: 'success',
						status: response?.data?.success,
						data: response?.data?.data,
					},
				});
			})
			.catch((error) => {
				// HANDLE ERROR MESSAGE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.updateMembership,
					payload: {
						message: handleMembershipError('simple', error),
						status: false,
						data: {},
					},
				});
			});
	};
};

const updateMembershipPlan = (id, userData) => {
    const object = userData ? {
        membershipId: id,
        userData
    } : id;

    return async (dispatch) => {
        // 1. Start Loading
        dispatch(allActions.global.Loader(true));

        try {
            const response = await axios.post(`${BASEURL}/api/membership/create-usermembership`, object);

            const successPayload = {
                message: userData
                    ? `Membership updated successfully for ${userData?.firstname + ' ' + userData?.lastname}.`
                    : 'Membership updated successfully.',
                status: response?.data?.success,
                data: response?.data?.data,
            };

            dispatch({
                type: MEMBERSHIP_ACTION_TYPE.updateMembershipPlan,
                payload: successPayload,
            });

            return { success: true, ...successPayload };

        } catch (error) {
            const errorMessage = handleMembershipError('simple', error);
            dispatch({
                type: MEMBERSHIP_ACTION_TYPE.updateMembershipPlan,
                payload: {
                    message: errorMessage,
                    status: false,
                    data: {},
                },
            });
            return { success: false, message: errorMessage };

        } finally {
            // 2. Stop Loading (runs for both success and error)
            dispatch(allActions.global.Loader(false));
        }
    };
};

const resetPlanLimit = (userId) => {
	return async (dispatch) => {
		axios
			.post(`${BASEURL}/api/membership/reset-plan-limit/${userId}`)
			.then((response) => {
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.resetPlanLimit,
					payload: {
						message: response?.data?.data?.message || 'Plan limit reset successfully.',
						status: response?.data?.success,
						data: response?.data?.data,
					},
				});
			})
			.catch((error) => {
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.resetPlanLimit,
					payload: {
						message: handleMembershipError('simple', error),
						status: false,
						data: {},
					},
				});
			});
	};
};

const allMembershipPlan = () => {
	return async (dispatch) => {
		axios
			.get(`${BASEURL}/api/membership/get-allMembershipPlan`)
			.then((response) => {
				// HANDLE RESPONSE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.allMembershipPlan,
					payload: {
						message: 'success',
						status: response?.data?.success,
						data: response?.data?.data,
					},
				});
			})
			.catch((error) => {
				// HANDLE ERROR MESSAGE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.allMembershipPlan,
					payload: {
						message: handleMembershipError('simple', error),
						status: false,
						data: {},
					},
				});
			});
	};
};
// get all membership plan
const getAllMembershipPlanByAdmin = ( page = 1, per_page = 10, fullname, membershipType, sortBy = 'id', order = 'DESC' , fromDate , toDate) => {
	const params = { page, per_page, fullname, membershipType, sortBy, order };
	 if (fromDate) {
                params.fromDate = new Date(fromDate).toISOString().split('T')[0];
                params.toDate = new Date(toDate).toISOString().split('T')[0];
            }
	return async (dispatch) => {
		axios
			.get(`${BASEURL}/api/membership/getAll-usermembership-byAdmin`,
				{params: params})
			.then((response) => {
				// HANDLE RESPONSE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.getAllMembershipPlanByAdmin,
					payload: {
						message: 'success',
						status: response?.data?.success,
						data: response?.data?.data,
					},
				});
			})
			.catch((error) => {
				// HANDLE ERROR MESSAGE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.getAllMembershipPlanByAdmin,
					payload: {
						message: handleMembershipError('simple', error),
						status: false,
						data: {},
					},
				});
			});
	};
};

// 
const createMembershipByAdmin = (membership) => {
	return async (dispatch) => {
		axios
			.post(`${BASEURL}/api/membership/create-usermembership-byAdmin`, membership)
			.then((response) => {
				// HANDLE RESPONSE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.createMembershipByAdmin,
					payload: {
						message: 'success',
						status: response?.data?.success,
						data: response?.data?.data,
					},
				});
			})
			.catch((error) => {
				// HANDLE ERROR MESSAGE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.createMembershipByAdmin,
					payload: {
						message: handleMembershipError('simple', error),
						status: false,
						data: {},
					},
				});
			});
	};
};

//
const retryForceMembershipByAdmin = (id, userData) => {
    const object = userData ? {
        membershipId: id,
        userData
    } : id;

    return async (dispatch) => {
        // 1. Start Loading
        dispatch(allActions.global.Loader(true));

        try {
            const response = await axios.post(`${BASEURL}/api/membership/retry-force-membership-byAdmin`, object);

            const successPayload = {
                message: `Payment retry initiated for ${userData?.firstname + ' ' + userData?.lastname}.`,
                status: response?.data?.success,
                data: response?.data?.data,
            };

            dispatch({
                type: MEMBERSHIP_ACTION_TYPE.retryForceMembershipByAdmin,
                payload: successPayload,
            });

            return { success: true, ...successPayload };

        } catch (error) {
            const errorMessage = handleMembershipError('simple', error);
            dispatch({
                type: MEMBERSHIP_ACTION_TYPE.retryForceMembershipByAdmin,
                payload: {
                    message: errorMessage,
                    status: false,
                    data: {},
                },
            });
            return { success: false, message: errorMessage };

        } finally {
            // 2. Stop Loading (runs for both success and error)
            dispatch(allActions.global.Loader(false));
        }
    };
};

// delete membership
const deleteMembershipPlan = (stripeSubId) => {
	return async (dispatch) => {
		axios
			.delete(`${BASEURL}/api/membership/delete-membership/${stripeSubId}`)
			.then((response) => {
				// HANDLE RESPONSE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.deleteMembershipPlan,
					payload: {
						message: response?.data?.data?.message || 'Subscription will be cancelled at the end of your billing period',
						status: response?.data?.success,
						data: response?.data?.data,
					},
				});
			})
			.catch((error) => {
				// HANDLE ERROR MESSAGE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.deleteMembershipPlan,
					payload: {
						message: handleMembershipError('simple', error),
						status: false,
						data: {},
					},
				});
			});
	};
};

const cancelFreeTrial = () => {
	return async (dispatch) => {
		axios
			.post(`${BASEURL}/api/membership/cancel-free-trial`)
			.then((response) => {
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.deleteMembershipPlan,
					payload: {
						message: response?.data?.data?.message || 'Free trial cancelled successfully',
						status: response?.data?.success,
						data: response?.data?.data,
					},
				});
			})
			.catch((error) => {
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.deleteMembershipPlan,
					payload: {
						message: handleMembershipError('simple', error),
						status: false,
						data: {},
					},
				});
			});
	};
};

/** Paid-plan Stripe trial: cancel in Stripe immediately and clear trial/billing fields (same Redux outcome as deleteMembershipPlan). */
const cancelTrialSubscription = (stripeSubId) => {
	return async (dispatch) => {
		axios
			.post(`${BASEURL}/api/membership/cancel-trial-subscription`, { stripeSubId })
			.then((response) => {
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.deleteMembershipPlan,
					payload: {
						message: response?.data?.data?.message || 'Trial subscription cancelled',
						status: response?.data?.success,
						data: response?.data?.data,
					},
				});
			})
			.catch((error) => {
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.deleteMembershipPlan,
					payload: {
						message: handleMembershipError('simple', error),
						status: false,
						data: {},
					},
				});
			});
	};
};
// sync membership with stripe
const syncMembershipWithStripe = (membershipId) => {
	return async (dispatch) => {
		// Set loading state
		dispatch({
			type: MEMBERSHIP_ACTION_TYPE.syncMembershipWithStripe,
			payload: {
				message: '',
				status: 'loading',
				data: {},
			},
		});

		axios
			.post(`${BASEURL}/api/membership/sync-membership-with-stripe/${membershipId}`)
			.then((response) => {
				// HANDLE RESPONSE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.syncMembershipWithStripe,
					payload: {
						message: 'success',
						status: response?.data?.success,
						data: response?.data?.data,
					},
				});
			})
			.catch((error) => {
				// HANDLE ERROR MESSAGE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.syncMembershipWithStripe,
					payload: {
						message: handleMembershipError('simple', error),
						status: false,
						data: {},
					},
				});
			});
	};
};

// 
const handleMembershipError = (type, error) => {
	if (type === 'simple') {
		return error.code === 'ERR_NETWORK'
			? error?.message
			: error?.response?.data?.error
				? error?.response?.data?.error
				: 'Internel Server Error!';
	}
};

const addNotes = (membershipId, notes) => {
	return async (dispatch) => {
		axios
			.post(`${BASEURL}/api/membership/add-notes/${membershipId}`, {notes})
			.then((response) => {
				// HANDLE RESPONSE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.addNotes,
					payload: {
						message: response?.data?.success,
						status: response?.data?.success,
					},
				});
			})
			.catch((error) => {
				// HANDLE ERROR MESSAGE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.addNotes,
					payload: {
						message: handleMembershipError('simple', error),
						status: false,
						data: {},
					},
				});
			});
	};
};

const sendBulkReminders = (allEmails, emailTemplate, billingLink) => {
	return async (dispatch) => {
		axios
			.post(`${BASEURL}/api/membership/send-bulk-reminders`, { allEmails, emailTemplate, windowLocation: billingLink })
			.then((response) => {
				// HANDLE RESPONSE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.sendBulkReminders,
					payload: {
						message: response?.data?.success,
						status: response?.data?.success,
					},
				});
			})
			.catch((error) => {
				// HANDLE ERROR MESSAGE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.sendBulkReminders,
					payload: {
						message: handleMembershipError('simple', error),
						status: false,
						data: {},
					},
				});
			});
	};
};

const sendReminder = (oneEmail, emailTemplate, billingLink) => {
	return async (dispatch) => {
		axios
			.post(`${BASEURL}/api/membership/send-reminder`, { oneEmail, emailTemplate, windowLocation: billingLink })
			.then((response) => {
				// HANDLE RESPONSE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.sendReminder,
					payload: {
						message: response?.data?.success,
						status: response?.data?.success,
					},
				});
			})
			.catch((error) => {
				// HANDLE ERROR MESSAGE
				dispatch({
					type: MEMBERSHIP_ACTION_TYPE.sendReminder,
					payload: {
						message: handleMembershipError('simple', error),
						status: false,
						data: {},
					},
				});
			});
	};
};

const retryPayment = (membershipId) => {
	return async (dispatch) => {
		try {
			const response = await axios.post(`${BASEURL}/api/membership/retry-payment`, { membershipId });
			return { success: true, data: response?.data?.data };
		} catch (error) {
			return { success: false, message: error?.response?.data?.error || 'Payment retry failed' };
		}
	};
};

const cancelSubscription = (membershipId, cancelType = 'immediate', cancelDate = null) => {
	return async (dispatch) => {
		try {
			const payload = { membershipId, cancelType };
			if (cancelDate) payload.cancelDate = cancelDate;
			const response = await axios.post(`${BASEURL}/api/membership/cancel-subscription`, payload);
			return { success: true, data: response?.data?.data };
		} catch (error) {
			return { success: false, message: error?.response?.data?.error || 'Cancel failed' };
		}
	};
};

const reactivateSubscription = (stripeSubId) => {
	return async (dispatch) => {
		try {
			const response = await axios.post(`${BASEURL}/api/membership/reactivate-subscription`, { stripeSubId });
			return { success: true, data: response?.data?.data };
		} catch (error) {
			return { success: false, message: error?.response?.data?.error || 'Reactivation failed' };
		}
	};
};

// Assign complimentary plan to a tax pro (admin/closer only)
const assignComplimentaryPlan = (userId, membershipId, reason) => {
	return async () => {
		try {
			const response = await axios.post(`${BASEURL}/api/membership/assign-complimentary-plan`, {
				user_id: userId,
				membership_Id: membershipId,
				reason,
			});
			return { success: true, data: response?.data?.data };
		} catch (error) {
			return {
				success: false,
				message: error?.response?.data?.error || error?.response?.data?.message || 'Failed to assign complimentary plan',
			};
		}
	};
};

// Remove an active complimentary plan (admin only)
const removeComplimentaryPlan = (membershipId, reason) => {
	return async () => {
		try {
			const response = await axios.post(`${BASEURL}/api/membership/remove-complimentary-plan`, {
				membership_id: membershipId,
				reason,
			});
			return { success: true, data: response?.data?.data };
		} catch (error) {
			return {
				success: false,
				message: error?.response?.data?.error || error?.response?.data?.message || 'Failed to remove complimentary plan',
			};
		}
	};
};

// Get current complimentary plan status for a user
const getComplimentaryPlan = (userId) => {
	return async () => {
		try {
			const response = await axios.get(`${BASEURL}/api/membership/complimentary-plan/${userId}`);
			return { success: true, data: response?.data?.data };
		} catch (error) {
			return {
				success: false,
				message: error?.response?.data?.error || error?.response?.data?.message || 'Failed to fetch complimentary plan',
			};
		}
	};
};

export const membership = {
	retryForceMembershipByAdmin,
	addNotes,
	sendBulkReminders,
	sendReminder,
	initialRegisterMembership,
	getMembership,
	updateMembership,
	updateMembershipPlan,
	resetPlanLimit,
	allMembershipPlan,
	createMembershipByAdmin,
	getAllMembershipPlanByAdmin,
	deleteMembershipPlan,
	cancelTrialSubscription,
	cancelFreeTrial,
	syncMembershipWithStripe,
	retryPayment,
	cancelSubscription,
	reactivateSubscription,
	assignComplimentaryPlan,
	removeComplimentaryPlan,
	getComplimentaryPlan,
};

